import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import AnalysisTablePalette from '../components/AnalysisTablePalette';
import './TipsTest.css';

const labels = {
    ms1: 'MS 1', msx: 'MS X', ms2: 'MS 2', iy05: 'İY 0.5 Üst',
    iy15: 'İY 1.5 Üst', ms25: 'MS 2.5 Üst', ms35: 'MS 3.5 Üst', kgv: 'KG Var',
};

const TipsTest = () => {
    const [odds, setOdds] = useState({ o1: '', ox: '', o2: '' });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [result, setResult] = useState(null);
    const [matchDates, setMatchDates] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const [matches, setMatches] = useState([]);
    const [selectedMatch, setSelectedMatch] = useState(null);
    const [matchesLoading, setMatchesLoading] = useState(false);

    const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

    useEffect(() => {
        fetch('/api/match-dates', { headers: authHeaders() })
            .then((response) => response.ok ? response.json() : Promise.reject(new Error()))
            .then((dates) => setMatchDates(dates))
            .catch(() => setMatchDates([]));
    }, []);

    useEffect(() => {
        setSelectedMatch(null);
        setMatches([]);
        if (!selectedDate) return;
        setMatchesLoading(true);
        fetch(`/api/matches-by-date?date=${encodeURIComponent(selectedDate)}`, { headers: authHeaders() })
            .then((response) => response.ok ? response.json() : Promise.reject(new Error()))
            .then((items) => setMatches(items))
            .catch(() => setError('Seçilen tarihin maçları yüklenemedi.'))
            .finally(() => setMatchesLoading(false));
    }, [selectedDate]);

    const matchOptions = matches.map((match) => ({
        value: match.id,
        label: `${match.league_code || '—'} | ${match.match_time || '—'} | ${match.home_team} - ${match.away_team}`,
        match,
    }));

    const handleMatchChange = (option) => {
        setSelectedMatch(option);
        if (!option) return;
        const selected = option.match;
        setOdds({
            o1: selected.ft_1_odd != null ? String(selected.ft_1_odd) : '',
            ox: selected.ft_x_odd != null ? String(selected.ft_x_odd) : '',
            o2: selected.ft_2_odd != null ? String(selected.ft_2_odd) : '',
        });
        setResult(null);
        setError(selected.ft_1_odd == null || selected.ft_x_odd == null || selected.ft_2_odd == null
            ? 'Seçilen maçın bazı 1-X-2 oranları henüz mevcut değil.' : '');
    };

    const updateOdd = (key, value) => setOdds((current) => ({ ...current, [key]: value }));

    const handleAnalyze = async (event) => {
        event.preventDefault();
        if (!odds.o1 && !odds.ox && !odds.o2) {
            setError('En az bir açılış oranı girmelisiniz.');
            return;
        }
        setLoading(true);
        setError('');
        setResult(null);
        try {
            const params = new URLSearchParams();
            Object.entries(odds).forEach(([key, value]) => value && params.set(key, value.replace(',', '.')));
            const response = await fetch(`/api/tipstest?${params.toString()}`);
            const data = await response.json();
            if (!response.ok) setError(data.error || 'Analiz sırasında bir hata oluştu.');
            else setResult(data);
        } catch (requestError) {
            setError('Sunucuya ulaşılamadı. Lütfen tekrar deneyin.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="tips-lab-page">
            <div className="breadcrumb-section breadcrumb-bg">
                <div className="container"><div className="row"><div className="col-lg-8 offset-lg-2 text-center">
                    <div className="breadcrumb-text"><p>İddaa Açılış Oran Analizi</p><h1>Açılış Analiz</h1></div>
                </div></div></div>
            </div>

            <div className="tips-lab-content"><div className="container"><div className="row"><div className="col-lg-12">
                <div className="section-title text-center">
                    <h3><span className="orange-text">Açılış Analiz</span></h3>
                </div>

                <form className="tipstest-panel tt1-odds-panel" onSubmit={handleAnalyze}>
                    <div className="tt1-match-picker">
                        <div className="tipstest-field">
                            <label>Maç tarihi</label>
                            <select value={selectedDate} onChange={(event) => setSelectedDate(event.target.value)}>
                                <option value="">Tarih seçin</option>
                                {matchDates.map((date, index) => <option value={date} key={date}>
                                    {['Bugün', 'Yarın', 'Ertesi Gün'][index] || date} ({date})
                                </option>)}
                            </select>
                        </div>
                        <div className="tipstest-field tt1-match-select">
                            <label>Maç seç</label>
                            <Select value={selectedMatch} onChange={handleMatchChange} options={matchOptions}
                                isClearable isSearchable isDisabled={!selectedDate || matchesLoading}
                                placeholder={matchesLoading ? 'Maçlar yükleniyor...' : 'Maç seçin'}
                                classNamePrefix="tt1-react-select" />
                        </div>
                    </div>
                    <div className="tt1-picker-divider"><span>veya oranları elle girin</span></div>
                    <div className="tt1-odds-inputs">
                        {[['o1', '1 Oranı'], ['ox', 'X Oranı'], ['o2', '2 Oranı']].map(([key, label]) => (
                            <div className="tipstest-field" key={key}>
                                <label>{label}</label>
                                <input type="text" inputMode="decimal" value={odds[key]} placeholder="Örn: 2.10"
                                    onChange={(event) => updateOdd(key, event.target.value)} />
                            </div>
                        ))}
                    </div>
                    <p className="tt1-form-hint">Kullanmak istemediğiniz oran alanını boş bırakabilirsiniz.</p>
                    <div className="tipstest-actions"><button type="submit" className="boxed-btn" disabled={loading}>
                        {loading ? 'Arşiv taranıyor...' : 'Analiz Et'}
                    </button></div>
                    {error && <div className="tipstest-error">{error}</div>}
                </form>

                {result && <div className="tipstest-results tt1-results">
                    <div className="tt1-result-header">
                        <div><span className="tt2-eyebrow">Açılış Analiz</span><h4>{result.sample_size} Maçlık İstatistik Paneli</h4></div>
                        <span className="tt1-input-summary">1: {result.inputs.o1 ?? '—'} · X: {result.inputs.ox ?? '—'} · 2: {result.inputs.o2 ?? '—'}</span>
                    </div>

                    {result.fallback_used && <div className="tt1-fallback-note">
                        Girilen oranların dinamik aralığında birebir eşleşme bulunamadı. Bu nedenle arşivdeki en yakın 20 olasılık profili gösteriliyor.
                    </div>}

                    <div className="tt1-stats-grid">
                        {Object.entries(result.stats).map(([key, stat]) => <div className="tt1-stat-card" key={key}>
                            <span>{labels[key]}</span><strong>%{stat.percentage}</strong>
                            <small>{stat.success}/{stat.n} maç · %95 GA [{stat.ci_low}–{stat.ci_high}]</small>
                        </div>)}
                    </div>

                    <h4 className="tt2-bolum-baslik">Arşivdeki En Yakın Maçlar</h4>
                    <AnalysisTablePalette>
                        <table className="table tt2-table tt1-match-table"><thead><tr>
                            <th>Tarih</th><th>Lig</th><th>Maç</th><th>Oranlar</th><th>İY</th><th>MS</th><th>İY/MS</th><th>Gol</th>
                        </tr></thead><tbody>{result.matches.map((match) => <tr key={match.id} className={match.hot ? 'tt1-hot-row' : ''}>
                            <td>{match.date || '—'}</td><td>{match.league || '—'}</td>
                            <td className="tt2-mac-adi">{match.home} - {match.away}{match.hot && <span className="tt1-hot">🔥</span>}</td>
                            <td>{match.odds.o1} / {match.odds.ox} / {match.odds.o2}</td><td>{match.ht}</td><td><strong>{match.ft}</strong></td>
                            <td>{match.htft}</td><td>{match.total_goals}</td>
                        </tr>)}</tbody></table>
                    </AnalysisTablePalette>

                    <div className="tt1-trends-grid">
                        {[['İlk Yarı Skor Trendi', result.trends.ht], ['Maç Sonu Skor Trendi', result.trends.ft]].map(([title, trends]) => <div className="tt1-trend-card" key={title}>
                            <h5>{title}</h5>{trends.map((trend) => <div className="tt1-trend-row" key={trend.score}>
                                <strong>{trend.score}</strong><span>{trend.count} maç</span><em>%{trend.percentage}</em>
                            </div>)}
                        </div>)}
                    </div>
                    <p className="tipstest-disclaimer">Sonuçlar geçmiş açılış oranlarına dayalı istatistiksel analizdir; kesinlik garantisi vermez.</p>
                </div>}
            </div></div></div></div>
        </div>
    );
};

export default TipsTest;
